import React, { useState } from 'react'
import { Box, Text, Flex } from 'rebass/styled-components'
import { Input } from '@rebass/forms/styled-components'
import styled from 'styled-components'
import axios from 'axios-jsonp-pro'
import AnimationWrapper from '../../helpers/Animations'

const NewsletterForm = styled(Box)` 
    .data-entry {
        align-items: flex-start;
        border-color: ${(props) => props.theme.colors.white};
        border-style: solid;
        border-width: 1px;
        display: flex;
        justify-content: flex-start;
        padding: 4px;

        div {
            flex-grow: 1;

            &.submit {
                align-self: stretch;
                border-color: ${(props) => props.theme.colors.white};
                border-style: solid;
                border-width: 0 0 0 1px;
                flex-basis: 82px;
                flex-grow: 0;
                max-width: 82px;
                position: relative;
            }
        }
    }

    input[type=text],
    input[type=email] {
        border-width: 0;
        color: ${(props) => props.theme.colors.white};
        font-family: ${(props) => props.theme.fonts.body};
        margin-top: 0;
        padding-bottom: 10px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 10px;
        opacity: 0.6;

        transition-duration: 200ms;
        transition-timing-function: ease-out;
        transition-property: opacity;

        will-change: opacity;

        &:hover {
            opacity: 1.0;
        }

        &:focus {
            outline: none;
        }
    }

    input[type=submit] {
        background-color: transparent;
        border-width: 0;
        height: 100%;
        left: -1px;
        margin: 0;
        position: absolute;
        top: 0;
        transition-duration: 150ms;
        transition-property: color;
        transition-timing-function: ease-out;
        width: calc(100% + 1px);
        will-change: color;

        &:hover {
            background-color: ${(props) => props.theme.colors.aquaDark};
            color: ${(props) => props.theme.colors.white};
        }
    }
`

const Newsletter = () => {
    const url = typeof window !== 'undefined' ? window.location.href : 'Referring URL not available'

    return (
        <NewsletterForm>
            <Box
                as="form"
                method="post"
                id="subForm"
                role="form"
                aria-label="Subscribe to our newsletter"
                autoComplete="on"
                className='js-cm-form'
                action="https://www.createsend.com/t/subscribeerror?description="
                data-id='92D4C54F0FEC16E5ADC2B1904DE9ED1AC31A584D4A6E15EE4F4AE368622C68A1BC24576D601B4283CBCDF321900D4441FFA7814065B24F9DF56160CE66274374'
            >
                <Input type="hidden" name="referrer" value={url} />
                <Text
                    as="label"
                    color="white"
                    htmlFor="name-newsletter-signup"
                    pb="xs"
                    variant="h5"
                    sx={{
                        cursor: 'pointer',
                        display: 'block',
                        textTransform: 'uppercase',
                    }}
                >
                    Keep Ahead of the Pack
                </Text>
                <Flex flexDirection={['column', 'column', 'column', 'column', 'column', 'row']}>
                    <Box
                        mb={['xs', 'xs', 'xs', 'xs', 'xs', '0']}
                        mr={['0', '0', '0', '0', '0', 'xs']}
                        width={['100%', '100%', '100%', '100%', '100%', '40%']}
                    >
                        <Box className="data-entry">
                            <Input
                                autoComplete="name"
                                enterKeyHint="next"
                                id="name-newsletter-signup"
                                name="cm-name"
                                placeholder="Name"
                                type="text"
                            />
                        </Box>
                    </Box>
                    <Box width={['100%', '100%', '100%', '100%', '100%', '60%']}>
                        <Box className="data-entry">
                            <Box>
                                <Text
                                    as="label"
                                    htmlFor="email-newsletter-signup"
                                    hidden
                                >
                                    Email Address
                                </Text>
                                <Input
                                    autoComplete="email"
                                    enterKeyHint="done"
                                    id="email-newsletter-signup"
                                    name="cm-thtrkyh-thtrkyh"
                                    placeholder="Email Address"
                                    type="email"
                                    className="js-cm-email-input"
                                />
                            </Box>
                            <input id="wllhu" name="cm-ol-wllhu" type="checkbox" value="wllhu" hidden checked></input>
                            <Box className="submit">
                                <Input variant="darkMode.submit" aria-pressed="false" type="submit" value="Join" />
                            </Box>
                        </Box>
                    </Box>
                </Flex>
            </Box>
            <script type="text/javascript" src="https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"></script>
        </NewsletterForm>
    )
}

export default Newsletter
